import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import EmptyChatState from './components/EmptyChatState';
import ExamAiInsightsChat from './routes/ExamAiInsightsChat';

const ExamAiInsightsLazy = React.lazy(
	() => import(/* webpackChunkName : 'ExamAiInsights' */ './ExamAiInsights')
);

export default (store) => [
	{
		path: 'home/insights/exams-insights/exam-ai-insights',
		element: (
			<AsyncLoading
				component={
					<ExamAiInsightsLazy featureFlag="FeatureFlag:ShowAIInsigts" />
				}
			/>
		),
		children: [
			{ index: true, element: <EmptyChatState /> },
			ExamAiInsightsChat(store),
		],
	},
];
